module.exports = __webpack_public_path__ + "public/fonts/glyphicons-halflings-regular.svg";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.svg
// module id = 3840
// module chunks = 0